import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Card } from '../components/ui/Card';
import { handleOAuthCallback } from '../services/googleCalendarOAuthService';
import './Pages.css';

export const GoogleCalendarCallback: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState<string>('Processando autenticação...');

  useEffect(() => {
    const processCallback = async () => {
      const code = searchParams.get('code');
      const state = searchParams.get('state');
      const error = searchParams.get('error');

      const result = await handleOAuthCallback(code, state, error);

      if (result.success) {
        setStatus('success');
        setMessage('Google Calendar conectado com sucesso!');
        setTimeout(() => {
          navigate('/agenda');
        }, 2000);
      } else {
        setStatus('error');
        setMessage(result.error || 'Erro ao conectar Google Calendar');
      }
    };

    processCallback();
  }, [searchParams, navigate]);

  return (
    <div className="ns-page" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
      <Card
        title={status === 'loading' ? '⏳ Conectando...' : status === 'success' ? '✅ Conectado!' : '❌ Erro'}
        subtitle={message}
      >
        {status === 'loading' && (
          <div style={{ textAlign: 'center', padding: '20px' }}>
            <div style={{ 
              width: '40px', 
              height: '40px', 
              border: '4px solid #e2e8f0',
              borderTop: '4px solid #0ea5e9',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite',
              margin: '0 auto 16px'
            }} />
            <p style={{ color: '#64748b', fontSize: '14px' }}>
              Aguarde enquanto processamos sua autenticação...
            </p>
          </div>
        )}
        
        {status === 'success' && (
          <div style={{ textAlign: 'center', padding: '20px' }}>
            <p style={{ color: '#065f46', fontSize: '14px', marginBottom: '16px' }}>
              Você será redirecionado para a agenda em instantes...
            </p>
            <button
              onClick={() => navigate('/agenda')}
              style={{
                padding: '8px 16px',
                background: '#0ea5e9',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: 500
              }}
            >
              Ir para Agenda
            </button>
          </div>
        )}

        {status === 'error' && (
          <div style={{ textAlign: 'center', padding: '20px' }}>
            <p style={{ color: '#991b1b', fontSize: '14px', marginBottom: '16px' }}>
              {message}
            </p>
            <button
              onClick={() => navigate('/agenda')}
              style={{
                padding: '8px 16px',
                background: '#0ea5e9',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: 500
              }}
            >
              Voltar para Agenda
            </button>
          </div>
        )}
      </Card>

      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

